import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Z-Index System
var Z_INDEX_REGISTRY = {
  Tooltip: 999999,
  Popover: 9999,
  Dropdown: 9998,
  Modal: 999,
  ControlFocus: 1
};
/** @typedef {keyof Z_INDEX_REGISTRY} ZIndexNamespace */

/**
 *
 * @param {ZIndexNamespace} namespace
 * @param {number} fallback
 */

export function getZIndex(namespace, fallback) {
  // Accounts for direct z-index value (number) usage.
  if (typeof namespace === 'number') {
    return namespace;
  } // Quick return for invalid namespaces


  if (typeof namespace !== 'string') {
    return fallback;
  }

  if (!Z_INDEX_REGISTRY[namespace] && typeof fallback === 'number') {
    Z_INDEX_REGISTRY[namespace] = fallback;
  }

  return Z_INDEX_REGISTRY[namespace];
}
export function getZIndexRegistry() {
  return _objectSpread({}, Z_INDEX_REGISTRY);
}